import React from "react";
import GeneralSMSCampaign from "../../../components/Pages/Campaign/General/SMS";

const GeneralSms = () => {
  return (
    <div>
      <GeneralSMSCampaign />
    </div>
  );
};

export default GeneralSms;
